import {get} from 'lodash';

export default (LABEL: {[key: string]: string}) => {
	const getLabel = (key:string) => get(LABEL, key, '');
	const required = true;

	const fields = {
		// HELPER
		hidden: {
			includesHandicap: {
				type: 'CheckboxGroup',
				options: [
					{value: getLabel('quoteRequest.customerHandicap.title')},
				],
			}
		},

		quoteRequest: {
			// TRIPS (DEFINED AT COMPONENT)

			// ACCOMODATION
			offerIncludesAccommodation: {
				type: 'CheckboxGroup',
				options: [
					{value: getLabel('quoteRequest.offerIncludesAccommodation.hotel')},
					{value: getLabel('quoteRequest.offerIncludesAccommodation.camping')},
					{value: getLabel('quoteRequest.offerIncludesAccommodation.hostFamily')},
					{value: getLabel('quoteRequest.offerIncludesAccommodation.churchGuestHouse')},
					{value: getLabel('quoteRequest.offerIncludesAccommodation.bungalow')},
					{value: getLabel('quoteRequest.offerIncludesAccommodation.apartment')},
					{value: getLabel('quoteRequest.offerIncludesAccommodation.other')},
				],
				label: '',
			},

			// DATES
			duration: {
				type: 'TextInput',
			},

			timeFlexibility: {
				type: "Selectbox",
				options: [
					{value: getLabel('quoteRequest.timeFlexibility.0')},
					{value: getLabel('quoteRequest.timeFlexibility.1D')},
					{value: getLabel('quoteRequest.timeFlexibility.3D')},
					{value: getLabel('quoteRequest.timeFlexibility.7D')},
					{value: getLabel('quoteRequest.timeFlexibility.14D')},
					{value: getLabel('quoteRequest.timeFlexibility.1M')},
				],
				hasEmptyOption: false,
			},

			alternativeTimeFlexibility: {
				type: "Selectbox",
				options: [
					{value: getLabel('quoteRequest.timeFlexibility.0')},
					{value: getLabel('quoteRequest.timeFlexibility.1D')},
					{value: getLabel('quoteRequest.timeFlexibility.3D')},
					{value: getLabel('quoteRequest.timeFlexibility.7D')},
					{value: getLabel('quoteRequest.timeFlexibility.14D')},
				],
				hasEmptyOption: false,
			},

			// TRANSPORT
			offerIncludesTransportation: {
				type: 'CheckboxGroup',
				options: [
					{value: getLabel('quoteRequest.offerIncludesTransportation.train')},
					{value: getLabel('quoteRequest.offerIncludesTransportation.bus')},
					{value: getLabel('quoteRequest.offerIncludesTransportation.self')},
					{value: getLabel('quoteRequest.offerIncludesTransportation.plane')},
					{value: getLabel('quoteRequest.offerIncludesTransportation.longDistanceBus')},
				],
				label: '',
			},

			departureStation: {
				type: 'TextInput',
				required,
				maxLength: 80,
				watch: {
					name: 'quoteRequest.offerIncludesTransportation',
					value: getLabel('quoteRequest.offerIncludesTransportation.train'),
				},
			},

			departureAirport: {
				type: 'TextInput',
				required,
				maxLength: 80,
				watch: {
					name: 'quoteRequest.offerIncludesTransportation',
					value: getLabel('quoteRequest.offerIncludesTransportation.plane'),
				},
			},

			departureBusStation: {
				type: 'TextInput',
				required,
				maxLength: 80,
				watch: {
					name: 'quoteRequest.offerIncludesTransportation',
					value: getLabel('quoteRequest.offerIncludesTransportation.longDistanceBus'),
				},
			},

			// BUDGET
			offerPrice: {
				type: 'TextInput',
				required,
			},

			// PARTICIPANTS
			offerIncludesParticipants: {
				totalAmountOfParticipants: {
					type: 'TextInput',
					label: getLabel('quoteRequest.offerIncludesParticipants.total'),
					required,
				},
			},

			offerIncludesSupervisors: {
				type: 'TextInput',
				required,
			},

			minCustomerAge: {
				type: "Selectbox",
				options: [
					{value: getLabel('quoteRequest.ageRange.under14')},
					{value: getLabel('quoteRequest.ageRange.14')},
					{value: getLabel('quoteRequest.ageRange.15')},
					{value: getLabel('quoteRequest.ageRange.16')},
					{value: getLabel('quoteRequest.ageRange.17')},
					{value: getLabel('quoteRequest.ageRange.18')},
				],
				hasEmptyOption: false,
				required,
			},

			maxCustomerAge: {
				type: "Selectbox",
				options: [
					{value: getLabel('quoteRequest.ageRange.under14')},
					{value: getLabel('quoteRequest.ageRange.14')},
					{value: getLabel('quoteRequest.ageRange.15')},
					{value: getLabel('quoteRequest.ageRange.16')},
					{value: getLabel('quoteRequest.ageRange.17')},
					{value: getLabel('quoteRequest.ageRange.18')},
				],
				hasEmptyOption: false,
			},

			offerIncludesComplimentarySeats: {
				type: 'TextInput',
			},

			customerHandicap: {
				type: 'TextArea',
				required,
				watch: {
					name: 'hidden.includesHandicap',
					value: getLabel('quoteRequest.customerHandicap.title'),
				},
			},
		},

		// NOTES
		description: {
			type: 'TextArea',
			maxLength: 250
		},

		// CUSTOMER
		customer: {
			salutation: {
				type: "RadioGroup",
				options: [
					{value: getLabel('customer.salutation.Frau')},
					{value: getLabel('customer.salutation.Herr')},
					{value: getLabel('customer.salutation.Divers')},
				],
				required,
			},
			additionalType: {
				type: "Selectbox",
				options: [
					{value: getLabel('customer.additionalType.teacher')},
					{value: getLabel('customer.additionalType.pupilUpTo16')},
					{value: getLabel('customer.additionalType.pupilFrom16')},
					{value: getLabel('customer.additionalType.otherUpTo16')},
					{value: getLabel('customer.additionalType.otherFrom16')},
				],
				required,
				hasEmptyOption: false,
			},
			additionalTypeHint: {
				htmlText: getLabel('customer.additionalType.hint'),
				conditions: [
					{
						field: 'customer.additionalType',
						values: [
							getLabel('customer.additionalType.pupilUpTo16'),
							getLabel('customer.additionalType.otherUpTo16'),
						],
					},
				],
				label: undefined
			},
			givenName: {
				type: "TextInput",
				required,
			},
			familyName: {
				type: "TextInput",
				required,
			},
			address: {
				contactType: {
					type: "RadioGroup",
					options: [
						{value: getLabel('customer.address.contactType.personal')},
						{value: getLabel('customer.address.contactType.official')},
					],
					required,
				},
				streetAddress: {
					type: "TextInput",
				},
				postalCode: {
					type: "TextInput",
				},
				addressLocality: {
					type: "TextInput",
				},
			},
			email: {
				type: "TextInput",
				required,
			},
			telephone: {
				type: "TextInput",
				required,
				pattern: /[0-9 \/\-\+\(\)]{4,}/,
			},
		},
		participant: {
			name: {
				type: "TextInput",
				required,
			},
			address: {
				streetAddress: {
					type: "TextInput",
				},
				postalCode: {
					type: "TextInput",
					required,
				},
				addressLocality: {
					type: "TextInput",
					required,
				},
			},
		},

		// REFERER
		referer: {
			type: "Selectbox",
			options: [
				{value: getLabel('referer.alreadyBooked')},
				{value: getLabel('referer.advertisement')},
				{value: getLabel('referer.recommendation')},
				{value: getLabel('referer.searchEngine')},
				{value: getLabel('referer.socialMedia')},
				{value: getLabel('referer.simpleTrain')},
				{value: getLabel('referer.podcast')},
				{value: getLabel('referer.catalogue')},
				{value: getLabel('referer.other')},
			],
			hasEmptyOption: false,
		},

		// NEWSLETTER
		newsletter: {
			type: "CheckboxGroup",
			options: [
				{value: getLabel('newsletter')},
			],
			label: '',
			note: getLabel('newsletter.description'),
		},
	};

	return {
		getConfig: (name: string) => ({
			name,
			label: getLabel(name),
			...get(fields, name, {})
		}),
		getLabel: (key: string) => {
			const label = get(LABEL, key, '');

			if (!label) {
				console.warn('Missing label for', key);
			}

			return label;
		},
	};
}
